
  <div class="mb-4">
    <label class="form-label fw-bold d-block text-center mb-3">Selecciona el día:</label>
    <div class="day-selector">
      <button
        *ngFor="let day of daysOfWeek"
        class="day-btn"
        [class.active]="selectedDay === day.value"
        (click)="selectDay(day.value)"
        type="button">
        {{ day.short }}
      </button>
    </div>
  </div>
